module.exports = __webpack_public_path__ + "img/feedback.c18ade34.svg";